import { useState, useContext, createContext } from "react";

const LangContext = createContext();

export const useLang = () => useContext(LangContext);

const LangProvider = ({ children }) => {
  const availableLangs = ["fr", "en"];

  const [lang, setLang] = useState(() => {
    let preferredLanguage = navigator.language;
    if (preferredLanguage) {
      preferredLanguage = preferredLanguage.split("-")[0];
    }

    if (!availableLangs.some((l) => l === preferredLanguage)) {
      preferredLanguage = "fr";
    }

    return preferredLanguage;
  });
  const updateLang = (language) => {
    if (availableLangs.some((l) => l === language)) setLang(language);
  };

  const value = [lang, updateLang];

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export default LangProvider;
